import { memo } from 'react';

import PhotoCarousel from './PhotoCarousel';

const PhotoGallery = ({
  options: { id },
}: {
  options: {
    id: string;
  };
}) => {
  return <PhotoCarousel photogalleryId={id} />;
};

export default memo(PhotoGallery);
